import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SignupVerifyComponent} from "./signup-verify.component";
import {AlertListModule, TranslateModule} from "@xref/ngx";
import {OmniLoaderModule} from "../../components/omni-loader/omni-loader.module";
import {RouterModule} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {ButtonModule} from "@xref/xref-lib";


@NgModule({
    declarations: [
        SignupVerifyComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        OmniLoaderModule,
        RouterModule,
        FormsModule,
        AlertListModule,
        ButtonModule
    ]
})
export class SignupVerifyModule {
}
